import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import mainPhotoDog from '@assets/images/home-dog.webp';



const MainPhoto = (): JSX.Element => {

	return (
		<div className='main-photo'>
			<div className='main-photo-text'>
				<p>BEZPEČNÉ A POHODLNÉ<br />
					POOPERAČNÍ LÍMCE<br />
					PRO PSY</p>

				<Link to={NavigateRoutesEnum.order} className='app-main-button'>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>
			
			<div className='main-photo-image'>
				<img src={mainPhotoDog} alt='main-content-photo' />
			</div>
		</div>
	);
};

export default MainPhoto;